import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-disabled',
  templateUrl: './login-disabled.component.html',
  styleUrls: ['./login-disabled.component.scss']
})
export class LoginDisabledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
